import { reportAxios } from "ultis/axios";

const getReportBusinessCSKH = (params) => {
  return reportAxios.get("/api/v1/reports/business-CSKH", {
    params,
  });
};

const getReportBusinessBCP = (params) => {
  return reportAxios.get("/api/v1/reports/business-BCP", {
    params,
  });
};

export const ReportBusinessApi = {
  getReportBusinessCSKH,
  getReportBusinessBCP,
};
